<template>
  <ul>
    <li
      v-for="(item, idx) in items"
      :key="idx"
      class="font-size-12"
      :style="`background-color: ${$_colors[`primary-lighten-${level + 1}`]}`"
    >
      <sidebar-list-item
        :item="item"
        @toggleItem="toggleItem(item, item.id !== currentLevelItemId)"
        :level="level + 1"
        :offersLayerId="offersLayerId"
        :area-unit="areaUnit"
      >
        <sidebar-list
          v-if="!!item.children?.length && item.id === currentLevelItemId"
          :items="item.children"
          :level="level + 1"
          :offersLayerId="offersLayerId"
          :area-unit="areaUnit"
        />
      </sidebar-list-item>
    </li>
  </ul>
</template>

<script>
import SidebarListItem from '@/components/sidebar/SidebarListItem';

export default {
  name: 'SidebarList',
  components: { SidebarListItem },
  props: {
    level: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default: () => {},
    },
    offersLayerId: {
      type: Number,
      required: true,
    },
    areaUnit: {
      type: String,
      default: 'ha',
    },
  },
  computed: {
    currentLevelItemId() {
      return +this.$route.query[this.level];
    },
  },
  methods: {
    toggleItem(item, value) {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      if (value) {
        Object.keys(query).forEach(key => {
          if (+key > this.level) delete query[key];
        });
        this.$router.push({ ...this.$route, query: { ...query, [this.level]: item.id } });
      } else {
        delete query[this.level];
        this.$router.push({ ...this.$route, query });
      }
    },
  },
};
</script>
